import { Text } from '@spotify-internal/encore-web';

import styles from './ChatDisclaimer.module.css';

export const ChatDisclaimer = () => (
  <Text
    as="p"
    variant="marginal"
    semanticColor="textSubdued"
    className={styles.root}
  >
    Note: AI can make mistakes. Verify important information.
  </Text>
);
